<template>
    <div>
        <v-row>
            <v-col cols="12">

            </v-col>
            <v-col cols="12">
                <v-tabs v-model="tab" centered>
                    <v-tab>Curva de aprendizaje</v-tab>
                    <v-tab>Comparativa</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item class="py-4">
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete v-model="AreasCurva" :items="AreasCurvaItems" outlined dense
                                    label="Areasdssgd" item-text="name" item-value="id" return-object
                                    @change="ModelateCurva"></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <div id="chart">
                                    <apexchart :key="chartKey" type="area" height="350" :options="chartOptions2"
                                        :series="series2">
                                    </apexchart>
                                </div>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item class="py-4">
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete v-model="AreasSeleccionadas" :items="Areas" outlined dense chips
                                    small-chips label="Areas" multiple item-text="name" item-value="id"
                                    return-object></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <div id="chart">
                                    <apexchart type="line" height="350" :options="chartOptions" :series="series">
                                    </apexchart>
                                </div>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from "@/helpers/axios";
import VueApexCharts from 'vue-apexcharts'
export default {

    name: 'ProgressByEval',
    props: ['filter'],
    components: {
        apexchart: VueApexCharts,
    },
    data: () => ({
        // modificadores de interfaz
        tab: 0,
        Somoshabiles: [],
        Areas: [],
        AreasCurvaItems: [],
        AreasCurva: [],
        AreasSeleccionadas: [],


        series: [],
        chartOptions: {
            chart: {
                height: 350,
                type: 'line',
            },
            stroke: {
                curve: 'smooth'
            },
            fill: {
                type: 'solid',
                opacity: [0.35, 1],
            },
            labels: [],
            markers: {
                size: 0
            },
            yaxis: [
                {
                    title: {
                        text: '',
                    },
                },
                {
                    opposite: true,
                    title: {
                        text: 'Progreso del estudiante',
                    },
                },
            ],
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return y.toFixed(0) + " points";
                        }
                        return y;
                    }
                }
            }
        },

        series2: [
            // {
            // name: 'Somos habiles',
            // dataSomos: [12, 8, 10, 10, 5, 11, 10]}, {
            // name: 'Simuladores',
            // dataSimu: [6, 8, 10, 12, 7, 11, 10]} 
        ],
        chartOptions2: {
            chart: {
                height: 350,
                type: 'area'
            },
            yaxis: {
                labels: {
                    formatter: (val) => {
                        // if (val > 100 || val < 0) {
                        //     return ""
                        // }
                        return val + "%"
                    },
                },
                min: 0,
                max: 100,
                forceNiceScale: false,
                tickAmount: 10
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                type: 'datetime',
                categories: []
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yy HH:mm'
                },
                y: {
                    formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return y.toFixed(2) + "%";
                        }
                        return y;
                    }
                }
            },
        }

    }),


    methods: {

        async fetchDataFromAPI() {
            const response = await axios.get("/metricaSomosHabiles/barChartByArea", {
                params: {

                    tipo_eval: "SOMOS HÁBILES",
                    id_al: this.filter.id_alumno,
                    status: false
                }
            });
            this.Somoshabiles = response.data.data;
            this.Areas = response.data.data;
            this.AreasCurvaItems = response.data.data
            this.processAPIData(this.Areas);
            this.processAPIDataCurva(this.AreasCurvaItems)
        },




        processAPIData(apiData) {
            this.Areas = apiData.map(item => ({
                id: item.id_area,
                name: item.desc_area,
                data: item.evaluaciones.map(ev => {
                    const date = new Date(ev.fecha_creacion);
                    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                    return {
                        x: formattedDate,
                        y: ev.verdaderas
                    }
                }),
                type: "area"
            }));

            this.updateSeries(this.Areas);
        },
        processAPIDataCurva(apiData) {
            this.AreasCurvaItems = apiData.map(item => ({
                id: item.id_area,
                name: item.desc_area,
                data: item.evaluaciones,
            }));
        },


        updateSeries(selectedAreas) {
            this.series = selectedAreas.map(area => ({
                name: area.name,
                data: area.data
            }));
        },

        async ModelateCurva() {
            console.log('Esta es AreaCurva seleccionada', this.AreasCurva);
            if (this.AreasCurva && this.AreasCurva.data) {
                let totalPruebas = this.AreasCurva.data.length;
                let TempSomoshabiles = this.AreasCurva.data.map(item => {
                    return ((parseInt(item.verdaderas) / parseInt(item.cantidad_preguntas)) * 100) / totalPruebas;
                });
                let sumaAcumulativa = 0;
                let sumaAcumulativaArray = TempSomoshabiles.map(valor => sumaAcumulativa += valor);
                let fechasSomos = this.AreasCurva.data.map(item => item.fecha_creacion);
                this.chartOptions2.xaxis.categories = fechasSomos;
                this.series2 = [{
                    name: 'Somos habiles',
                    data: sumaAcumulativaArray
                }];
                this.chartKey = Date.now()
                // console.log('Esta es la data modificada', this.series2);
            } else {
                console.error('No se pudo encontrar el array de datos en AreasCurva');
            }
        }
    },


    mounted() {
        // this.fetchDataGada()
        this.fetchDataFromAPI()
    },



    watch: {
        AreasSeleccionadas: {
            handler(newVal) {
                this.series = newVal.map(area => ({
                    name: area.name,
                    data: area.data
                }));
            },
            deep: true
        },

    }
}
</script>
